import { render, staticRenderFns } from "./Paquetes.vue?vue&type=template&id=2f1aa8c4&"
import script from "./Paquetes.vue?vue&type=script&lang=js&"
export * from "./Paquetes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports